<template>
  <div class="page page--call-ascenti">
    <div class="container">
      <h1>Symptom check already complete</h1>

      <hr class="my-2">

      <div class="leading-loose">
        <p>It looks like you have already completed a symptom check.</p>
        <p><router-link class="link" :to="routes.help">Get help with your booking</router-link></p>
        <p>Alternatively, give Ascenti a call on <a href="tel:+443301247271" class="link link-no-underline">0330 124 7271</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CallAscenti",

  mounted() {
    this.$gtm.trackView('Already complete', '/already-complete');
    this.setCurrentStep(null);

    this.setSurveyComplete(true);

    this.clearAnswers();

    this.setBodyPart(null);

    this.scrollToTop();
  },
}
</script>
